export const handleFilterChange = (value, fSet, fUnset, timeout, ff, clients, fSetDisplay) => {
    fSet.forEach(func => func(value));
    fUnset.forEach(func => func(""));
    clearTimeout(timeout);
    // Set a new timeout of 0.5 seconds
    timeout = setTimeout(() => {
        fSetDisplay(clients.filter(ff));
    }, 500);
}
